import { type AccountId, accountIdFormat } from "@redotech/redo-account-id";
import { HandlingUnitType } from "@redotech/redo-fulfillment-carrier-common/freight";
import { freightHandlingUnitIdFormat } from "@redotech/redo-fulfillment-id";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

const FreightHandlingUnitRowSchema_ = z.object({
  id: freightHandlingUnitIdFormat.schema,
  accountId: accountIdFormat.schema,
  name: z.string(),
  type: createEnum(HandlingUnitType, { enumName: "HandlingUnitType" }),
  length: z.number(),
  width: z.number(),
  height: z.number(),
  isDefault: z.boolean(),
  createdAt: z.date(),
  updatedAt: z.date(),
});
export const FreightHandlingUnitRowSchema: z.ZodType<FreightHandlingUnitRow> =
  FreightHandlingUnitRowSchema_;
export interface FreightHandlingUnitRow extends z.infer<
  typeof FreightHandlingUnitRowSchema_
> {}

export interface CreateFreightHandlingUnitInput {
  accountId: AccountId;
  name: string;
  type: HandlingUnitType;
  length: number;
  width: number;
  height: number;
  isDefault?: boolean;
}

export interface UpdateFreightHandlingUnitInput {
  name?: string;
  type?: HandlingUnitType;
  length?: number;
  width?: number;
  height?: number;
  isDefault?: boolean;
}
